export interface Review {
    name: string;
    rating: number;
    addedAt: string;
    details: string;
    review: string;
    courseInfo?: string; // Optional field for course information
}

// Sample reviews data
export const reviews: Review[] = [
    {
        name: "Antoni",
        rating: 5,
        addedAt: "2026-05-18",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Przyjemnie się ogląda i kurs jest zrobiony w bardzo przystępnej formie</p>"
    },
    {
        name: "Aleksander",
        rating: 5,
        addedAt: "2026-05-17",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Dzięki kursowi poprawiłem swoje oceny. Możliwość nauki do sprawdzianów bardzo mi pomaga</p>"
    },
    {
        name: "Ola",
        rating: 5,
        addedAt: "2026-05-17",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Nauczyłam się nie mieć rozpraszaczy przy biurku i zmieniać pozycję co jakiś czas</p>"
    },
    {
        name: "Tosia",
        rating: 5,
        addedAt: "2026-05-07",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Podoba mi sie i mi pomaga</p>"
    },
    {
        name: "Paweł",
        rating: 5,
        addedAt: "2026-05-05",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Ma pomocne sugestie o radzeniu sobie z czasem</p>"
    },
    {
        name: "Kacper",
        rating: 4,
        addedAt: "2026-04-29",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Oceniam go na 4 ponieważ nie za każdym razem cokolwiek wynosiłem z lekcji ale z niektórych już tak. Szczerze mega mi się przydał \"Plan dominacji\" , \"Fiszki\" , \"AI Czat\" i także funkcja dzięki której mogłem zaplanować wszystkie nadchodzące sprawdziany największy + to był taki że mogłem wygenerować fiszki i nie robić ich ręcznie. Też mi się podobały odznaki ponieważ mnie to motywowało do dalszego robienia kursu.</p>"
    },
    {
        name: "Oliwier",
        rating: 5,
        addedAt: "2026-04-23",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Lepiej organizuje sobie czas oraz codzienne życie i znajduję więcej czasu wolnego niż wcześniej.</p>"
    },
    {
        name: "Magda",
        rating: 5,
        addedAt: "2026-04-20",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Po rozpoczeciu nauki w liceum roznica poziomu byla tak wysoka, ze nie radzilam sobie z ocenami. dzieki kursowi jest mi teraz o wiele latwiej.</p>"
    },
    {
        name: "Filip",
        rating: 5,
        addedAt: "2026-04-20",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Dużo się nauczyłem jeśli chodzi o organizację</p>"
    },
    {
        name: "Ernest",
        rating: 5,
        addedAt: "2026-04-14",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Jest fajny i nie jest bardzo długi więc bardzo mi sie podoba</p>"
    },
    {
        name: "Jakub",
        rating: 4,
        addedAt: "2026-04-14",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Kurs dotyczący efektywnego działania okazuje się bardzo praktyczny i dobrze uporządkowany. Już od pierwszych modułów widać, że autor stawia na konkret, a nie lanie wody — co jest ogromnym plusem. Materiały są przejrzyste, a przykłady pomagają szybko zrozumieć, jak wdrożyć teorię w życie. Szczególnie wartościowe są techniki planowania dnia i sposoby na eliminowanie rozpraszaczy, które faktycznie działają w realnych warunkach, a nie tylko „na papierze”. Momentami kurs mógłby być bardziej dynamiczny, ale całość nadrabia solidną treścią. Po jego ukończeniu łatwiej ogarnąć chaos i skupić się na tym, co naprawdę ważne — a to już spora wygrana.</p>"
    },
    {
        name: "Monika",
        rating: 5,
        addedAt: "2026-04-12",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Kurs efektywnego dzialania pomógł mi lepiej zarządzać czasem i też dzięki kursowi mniej się uczę ale efektywniej</p>"
    },
    {
        name: "Leon",
        rating: 5,
        addedAt: "2026-04-09",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Jest intrygujący i przydatny chociaż wiele technik nauki znałem wcześniej. Warto jednak je powtórzyć.</p>"
    },
    {
        name: "Jan",
        rating: 5,
        addedAt: "2026-04-08",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>jest okej fajnie mi sie pracuje</p>"
    },
    {
        name: "Nadja",
        rating: 5,
        addedAt: "2026-04-07",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Kurs bardzo odmienił moje życie. Teraz widze wszystko inaczej , czuje że wiem co robić i mam większą pewność siebie . Poprawiłam sie diametralnie, moje oceny sie polepszyły dzięki kursowi .Poznałam swoje wartośći i uwierzyłam że osiągne swój cel . DZIĘKUJE!!!!</p>"
    },
    {
        name: "Aleksandra",
        rating: 5,
        addedAt: "2026-04-06",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>fajny no motywuje do nauki i pracy oraz pokazuje jak sobie radzic z jej brakiem</p>"
    },
    {
        name: "Dominika",
        rating: 5,
        addedAt: "2026-04-04",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Można się dowiedzieć wielu ciekawych rzeczy</p>"
    },
    {
        name: "Maciek",
        rating: 4,
        addedAt: "2026-04-01",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Kurs daje mi do zrozumienia co robię źle i jak to naprawić.</p>"
    },
    {
        name: "Zosia",
        rating: 5,
        addedAt: "2026-03-30",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: '<p>Daje dobre odpowiedzi jak się "ustabilizować". Pomaga uporządkowywać i stawia wymagania</p>'
    },
    {
        name: "Franek",
        rating: 5,
        addedAt: "2026-03-30",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>ten kurs jest super :}  :}</p>"
    },
    {
        name: "Agnieszka",
        rating: 5,
        addedAt: "2026-03-29",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Ciekawy, dający do myślenia, pomagający wo ogarnięciu wielu sparwa</p>"
    },
    {
        name: "Hanna",
        rating: 5,
        addedAt: "2026-03-29",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Póki co jest bardzo dobrze. Czasem te filmy nudzą ale ogólnie jest świetnie</p>"
    },
    {
        name: "Maja",
        rating: 5,
        addedAt: "2026-03-26",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Na ten moment mi dosyć pomaga . Bardziej się mobilizuje . Czasami mi nie wychodzi ale staram się aż tak nie dać tego do siebie żeby nie narzucać na siebie presji</p>"
    },
    {
        name: "Łucja",
        rating: 5,
        addedAt: "2026-03-23",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>jest fajnie, mam nadzieje że pomożę mi na całe liceum i później</p>"
    },
    {
        name: "Bartosz",
        rating: 5,
        addedAt: "2026-03-21",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Byłem nie chcetny lecz powoli zmienia mi sie nastawienie</p>"
    },
    {
        name: "Józef",
        rating: 5,
        addedAt: "2026-03-18",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>podoba mi się kurs, czuję że nauczyłem się czegoś przydatnego</p>"
    },
    {
        name: "Tomasz",
        rating: 5,
        addedAt: "2026-03-17",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Bardzo bardzo dobrze</p>"
    },
    {
        name: "Magda",
        rating: 4,
        addedAt: "2026-03-17",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Głównie nauczyłam się jak dobrze i umiejętnie organizować swój czas oraz rozplanowywać obowiązki i naukę tak abym się ze wszystkim wyrabiała i nie miała zaległości.</p>"
    },
    {
        name: "Magdalena",
        rating: 5,
        addedAt: "2026-03-15",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Kurs jest pomocny i wciągający</p>"
    },
    {
        name: "Wojciech",
        rating: 5,
        addedAt: "2026-03-15",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Naprawdę spoko, dużo się nauczyłem podczas tych trzech tygodni.</p>"
    },
    {
        name: "Piotr",
        rating: 5,
        addedAt: "2026-03-12",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Cały kurs bardzo mi się podoba</p>"
    },
    {
        name: "Karina",
        rating: 5,
        addedAt: "2026-03-12",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>bardzo ciekawy kurs dużo się dowiedziałam</p>"
    },
    {
        name: "Kacper",
        rating: 5,
        addedAt: "2026-03-11",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Sporo się dowiedziałem</p>"
    },
    {
        name: "Miłosz",
        rating: 5,
        addedAt: "2026-03-10",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>CIEKAWIE PRZEDstawionE fajne rozwiazania</p>"
    },
    {
        name: "Martyna",
        rating: 5,
        addedAt: "2026-03-09",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>jest bardzo dobrze opowiedziane. duzo można wynieść</p>"
    },
    {
        name: "Emilia",
        rating: 5,
        addedAt: "2026-03-09",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Kocham ten kurs! Bardzo pomocne zadania , które pozwalają na zrozumienie co jest dla mnie ważne , można dowiedzieć się,na co poświęca się najwięcej czasu , oraz dlaczego np. sprawdzian poszedł zle.Jak ' oderwać się' od telefonu czy komputera, z kursu można się dowiedzieć, jak nieodkładać ważnych rzeczy na pózniej,kiedy mamy najwięcej energii do nauki,jak uczyć się efektywnie, poznajemy techniki antystresowe i wiele więcej. Polecam,trochę kosztuje,ale myślę że warto go wykupić, ponieważ może pomóc w lepszych przygotowaniach do egzaminów,lepszej organizacji czasu, podejściu do nauki i oczywiście nauce.</p>"
    },
    {
        name: "Jonathan",
        rating: 5,
        addedAt: "2026-03-08",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>przejrzyście rozplanowane, bardzo mi pomogło</p>"
    },
    {
        name: "Ola",
        rating: 5,
        addedAt: "2026-03-02",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Uważam że jest fajna bardzo aplikacji i mam fajne doswiadczenia</p>"
    },
    {
        name: "Janek",
        rating: 5,
        addedAt: "2026-02-28",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Uważam, że kurs był bardzo pomocny i skuteczny. Pomógł mi w systematyczniejszej i efektywniejszej nauce. Dzięki czemu do większości testów podchodzę teraz z większym spokojem i opanowaniem. Przez co osiągam lepsze wyniki w nauce. W kursie podobało mi się otwarte podejście do uczestników.</p>"
    },
    {
        name: "Maciej",
        rating: 5,
        addedAt: "2026-02-25",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Dowiedziałem się nowych rzeczy które powoli wprowadzam i powoli dają skutki</p>"
    },
    {
        name: "Aleksander",
        rating: 5,
        addedAt: "2026-02-23",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>zaczynam powoli lepiej sie uczyc i rozumiec co przerabiam w szkole.</p>"
    },
    {
        name: "Krzysztof",
        rating: 5,
        addedAt: "2026-02-23",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Lepiej planuję, zarządzam swoim czasem, lepiej sypiam</p>"
    },
    {
        name: "Maria",
        rating: 5,
        addedAt: "2026-02-20",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Jak dotąd podoba mi się to i widzę postępy w moim życiu akademickim i osobistym.</p>"
    },
    {
        name: "OliM",
        rating: 5,
        addedAt: "2026-02-19",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>kurs bardzo fajny, wartościowy i widzę realne efekty. nauczyłam się nie marnować czasu, lepiej nim zarządzać, uczyć się efektywnie i systematycznie, wchodzić w stan flow, mniej się stresować np. przed sprawdzianami, ustalać priorytety, mieć pozytywne myślenie i wiele innych!</p>"
    },
    {
        name: "Szymon",
        rating: 5,
        addedAt: "2026-02-19",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Narazie bez zarzutów, zobaczymy co dalej:DD. Duzo przestrzeni na własną refleksje co jest bardzo dobre.</p>"
    },
    {
        name: "Maja",
        rating: 5,
        addedAt: "2026-02-18",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>poprawia mi to moja naukę.</p>"
    },
    {
        name: "Olivier",
        rating: 5,
        addedAt: "2026-02-17",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Jest bardzo interesujący i pomógł mi w zebraniu się do nakuki</p>"
    },
    {
        name: "Alicja",
        rating: 5,
        addedAt: "2026-02-15",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Podoba mi się, że filmy są krótkie i na temat. Kurs bardzo mi się podoba.</p>"
    },
    {
        name: "Zuzanna",
        rating: 5,
        addedAt: "2026-02-14",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Bardzo dobrze mi się pracuje z kursem.</p>"
    },
    {
        name: "Martyna",
        rating: 5,
        addedAt: "2026-02-13",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Bardzo podobal mi sie chronotyp snu.</p>"
    },
    {
        name: "Lena",
        rating: 5,
        addedAt: "2026-02-12",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>uwazam ze filmiki sa fajne i przyjemnie sie je oglada</p>"
    },
    {
        name: "Szymon",
        rating: 5,
        addedAt: "2026-02-12",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Przez ten kurs spędzam mniej czasu na naukę.</p>"
    },
    {
        name: "Szymon",
        rating: 5,
        addedAt: "2026-02-10",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Są omawiane ważne i przydatne rzeczy</p>"
    },
    {
        name: "Tomasz",
        rating: 5,
        addedAt: "2026-02-09",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Bardzo podoba mi się ten kurs</p>"
    },
    {
        name: "Paweł",
        rating: 5,
        addedAt: "2026-02-05",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>bardzo pomaga mi w nauce</p>"
    },
    {
        name: "Sylwia",
        rating: 5,
        addedAt: "2026-02-04",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Kurs jak do tej pory jest dobrze ułożony. Jasne tłumaczenia.</p>"
    },
    {
        name: "Piotr",
        rating: 5,
        addedAt: "2026-02-03",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Jest bardzo fajny ten kurs ,ale czuje ze potrzebuje jeszcze troche czasu na calkowita zmiane</p>"
    },
    {
        name: "Maja",
        rating: 5,
        addedAt: "2026-02-03",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Bardzo pomocny, rzeczy są dobrze tłumaczone, a filmiki nie za długie więc da się skupić.</p>"
    },
    {
        name: "Jan",
        rating: 5,
        addedAt: "2026-02-03",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Filmiki są bardzo przyjemne do oglądania i są z przekazem. Jestem szczęśliwy że uczestniczę w tym kursie.</p>"
    },
    {
        name: "Alicja",
        rating: 5,
        addedAt: "2026-02-01",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Kurs Efektywnego dzialania jest elementem ktorego brakuje w edukacji podstawowej. Jest Odpowiedni nie tylko dla mlodziezy ale i dla uczniow szkoly podstawowej, uświadamiając, motywując do brania odpowiedzialnosci za siebie i swoje dzialania. Warto !</p>"
    },
    {
        name: "Nadja",
        rating: 5,
        addedAt: "2026-01-29",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>zaczynam rozumieć co musze musze poprawić ,od przyszłego semestru biore sie za efektywna nauke\n</p>"
    },
    {
        name: "Oli",
        rating: 5,
        addedAt: "2026-01-27",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>nauka idzie mi o wiele lepiej</p>"
    },
    {
        name: "Adam",
        rating: 5,
        addedAt: "2026-01-27",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Bardzo podoba mi się kurs i jestem pewny, że będzie mi pomagał. Podoba mi się opcja cotygodniowych spotkań</p>"
    },
    {
        name: "Mateusz",
        rating: 5,
        addedAt: "2026-01-26",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Korzystałem z obu kursów, natomiast pierwszego nie dokończyłem. Postanowiłem zacząć od nowa ale z kursem 2.0 i muszę przyznać, że faktycznie zaczynam implementować zalecenia i wiele mi to pomaga</p>"
    },
    {
        name: "Karol",
        rating: 5,
        addedAt: "2026-01-26",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Jestem mile zaskoczony. Z niecierpliwością czekam na techniki nauki, gdyż czytałem trochę o nich w internecie i zastanawiam się co to będzie. Na plus to że treści nie są tylko stricte o nauce ale i o pokrewnych tematach.</p>"
    },
    {
        name: "Janek",
        rating: 5,
        addedAt: "2026-01-26",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Moje doświadczenia z kursem są dobre, mam wrażenie ,że kurs bardzo mi pomaga.</p>"
    },
    {
        name: "Zosia",
        rating: 5,
        addedAt: "2026-01-25",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Bardzo pomaga w nauce oraz skupieniu:)</p>"
    },
    {
        name: "Konrad",
        rating: 5,
        addedAt: "2026-01-22",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>bardzo dobre, pomaga w organizacji pracy</p>"
    },
    {
        name: "Emilia",
        rating: 5,
        addedAt: "2026-01-20",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Kurs bardzo pomocny. Dzięki niemu można nauczyć się jak zarządzać swoim czasem, aby mieć na wszystko czas co jest dla mnie bardzo ważne.</p>"
    },
    {
        name: "Michał",
        rating: 4,
        addedAt: "2026-01-19",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Pomaga mi w znalezieniu rzeczy, które powodują to ze się słabiej uczę</p>"
    },
    {
        name: "Lidia",
        rating: 5,
        addedAt: "2026-01-13",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Kurs jest bardzo ciekawy, pozwala mi dowiedzieć się wielu przydatnych informacji na różnorodne tematy. Pomaga mi w lepszym zaplanowaniu mojego czasu i pokonywaniu prokrastynacji.</p>"
    },
    {
        name: "Jakub",
        rating: 5,
        addedAt: "2026-01-13",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Trochę dużo materiału np. \"Idealna wersja siebie\" i same filmiki... No ale sam kurs super :)</p>"
    },
    {
        name: "Maksymilian",
        rating: 5,
        addedAt: "2026-01-11",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Podoba mi się w jaki sposób do tego podchodzicie. Wszystko jest uporządkowane i łatwo się w tym połapać</p>"
    },
    {
        name: "Maria",
        rating: 5,
        addedAt: "2026-01-10",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Jestem w połowie, a zajęcia nadal mnie interesują i motywują.</p>"
    },
    {
        name: "Tymoteusz",
        rating: 5,
        addedAt: "2026-01-04",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Kurs pomógł mi zrozumieć sporo rzeczy i pokazał jak sie lepiej uczyć</p>"
    },
    {
        name: "Ela",
        rating: 5,
        addedAt: "2025-12-30",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Zaczynam 3 tydzień i nie mam zarzutów</p>"
    },
    {
        name: "Olga",
        rating: 5,
        addedAt: "2025-12-28",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Kurs pomógł mi zarządzać lepiej swoim czasem i obowiązkami</p>"
    },
    {
        name: "Ewa",
        rating: 5,
        addedAt: "2025-12-27",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Bardzo podoba mi się ten kurs jestem dopiero na 2 tygodniu, a już udało mi się zauważyć zmiany w swoim podejściu do nauki. Obsługa platformy jest bardzo intuicyjna.</p>"
    },
    {
        name: "Pola",
        rating: 5,
        addedAt: "2025-12-27",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>jest super, bardzo mi pomaga w nauce na studia</p>"
    },
    {
        name: "Wojtek",
        rating: 5,
        addedAt: "2025-12-25",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Fajny uczę się tego co chciałem się uczyć</p>"
    },
    {
        name: "Weronika",
        rating: 5,
        addedAt: "2025-12-23",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Na początku bardzo odkladalam zaczecie go i mialam zaczety 1 tydzien, ale gdy zobaczylam kurs 2.0 to zaczelam go od poczatku i wydaje sie on dużo przyjemniejszy</p>"
    },
    {
        name: "Myroslava",
        rating: 5,
        addedAt: "2025-12-17",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>mi sie podoba jest bardzo przydatny</p>"
    },
    {
        name: "Kacper",
        rating: 5,
        addedAt: "2025-12-10",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Jeszcze wszystkiego nie zrobiłem ale na tym etapie co jestem czuje się świetnie</p>"
    },
    {
        name: "Alan",
        rating: 5,
        addedAt: "2025-11-25",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Wszystko okej, jest super</p>"
    },
    {
        name: "Zofia",
        rating: 5,
        addedAt: "2025-11-20",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>jest bardzo fajne. lepiej się uczę</p>"
    },
    {
        name: "Mateusz",
        rating: 5,
        addedAt: "2025-11-18",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>kurs wiele wyjaśnia i myślę, że powoli faktycznie zaczyna się przekładać na mój sposób działania.</p>"
    },
    {
        name: "Tymoteusz",
        rating: 5,
        addedAt: "2025-11-12",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Kurs od samego początku pomaga w zmianie myślenia. Oczywiście trzeba włożyć też trochę swojej pracy ale kurs naprawdę bardzo w tym pomaga i do tego zachęca.</p>"
    },
    {
        name: "Wojciech",
        rating: 5,
        addedAt: "2025-11-11",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Kurs pomógł mi w lepszym zrozumieniu siebie i swoich celów. Daje też przydatne do wykorzystania w przyszłości narzędzia.</p>"
    },
    {
        name: "Brak",
        rating: 5,
        addedAt: "2025-11-08",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Okej. Dowiedzialam się wielu nowych technik</p>"
    },
    {
        name: "Hanna",
        rating: 5,
        addedAt: "2025-11-07",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Bardzo ciekawy. Inspiruje i pomaga wiele zmienić.</p>"
    },
    {
        name: "Adam",
        rating: 5,
        addedAt: "2025-11-05",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Bardzo podoba mi się ten kurs i myślę, że spełnia swoje zadanie :)</p>"
    },
    {
        name: "Agnieszka",
        rating: 5,
        addedAt: "2025-11-02",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Dobre nie ma tutaj niczego do zarzucenia</p>"
    },
    {
        name: "Monika",
        rating: 5,
        addedAt: "2025-11-02",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Bardzo fajne są te kursy. Są treściwe i dużo da się zrozmieć</p>"
    },
    {
        name: "Artur",
        rating: 5,
        addedAt: "2025-11-02",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Kurs bardzo pomógł mi zmienić nastawienie do nauki. Lekcje są bardzo ciekawe i poruszają istotne tematy</p>"
    },
    {
        name: "Szymon",
        rating: 5,
        addedAt: "2025-10-26",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>kurs mi sie bardzo podpba bardzo jest pomocny i korzystam z tego</p>"
    },
    {
        name: "Daria",
        rating: 5,
        addedAt: "2025-10-22",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>moje doświadczenia z kursem są bardzo dobre a nawet bardzo dobre.</p>"
    },
    {
        name: "Łukasz",
        rating: 5,
        addedAt: "2025-10-16",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>szkoła nie jest tak męcząca i lepiej mi się uczy i widze efekty</p>"
    },
    {
        name: "Franek",
        rating: 5,
        addedAt: "2025-10-13",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Fajnie sie go robi</p>"
    },
    {
        name: "Julia",
        rating: 5,
        addedAt: "2025-10-12",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>ten kurs pomógł mi opanować naukę dzięki niemu dostaję lepsze oceny i łatwiej mi się skupić</p>"
    },
    {
        name: "Antoni",
        rating: 5,
        addedAt: "2025-10-06",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Jest ciekawy i pouczający.</p>"
    },
    {
        name: "Zosia",
        rating: 5,
        addedAt: "2025-10-03",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>kurs mi sie podoba staram sie wypełniać zalecenia</p>"
    },
    {
        name: "Michał",
        rating: 5,
        addedAt: "2025-10-01",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Kurs jest ciekawym doświadczeniem-pozdrawiam serdecnie</p>"
    },
    {
        name: "Agnieszka",
        rating: 4,
        addedAt: "2025-10-01",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Słucham z zainteresowaniem, trochę przeszkadza mi tempo mówienia prowadzącego (zbyt szybkie, przez co mam problem ze zrozumieniem niektórych wypowiedzi).</p>"
    },
    {
        name: "Szymon",
        rating: 5,
        addedAt: "2025-09-30",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p> Chcę działać i dalej poznawać sposoby do efektywnej nauki</p>"
    },
    {
        name: "Antoni",
        rating: 5,
        addedAt: "2025-09-29",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Jako iż miałem duży problem z prokrastynacją to wdrażanie pierwszych dwóch tygodni kursy szło dosyć opornie. Jednak na ten moment na pewno jest o wiele lepiej niż wczesniej</p>"
    },
    {
        name: "Michał",
        rating: 5,
        addedAt: "2025-09-29",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Ciekawe opowiadanie na temat w każdym z odcinków</p>"
    },
    {
        name: "Stasiu",
        rating: 5,
        addedAt: "2025-09-28",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Ten Kurs wpłynął na moją motywacje do działania</p>"
    },
    {
        name: "Kuba",
        rating: 5,
        addedAt: "2025-09-27",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>W tum kursie ja osobiście nie zmienił bym nic.</p>"
    },
    {
        name: "Anastazja",
        rating: 5,
        addedAt: "2025-09-26",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>kurs bardzo dużo mnie nauczył. teraz lepiej sie ucze i lepiej organizuje swój czas. nic mi nie brakowało wszystko było na wysokim poziomie</p>"
    },
    {
        name: "Mateusz",
        rating: 5,
        addedAt: "2025-09-25",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Dużo więcej słucham na lekcji i dużo lepiej się uczę. jest bardzo super i nic ująć ani nic dodać</p>"
    },
    {
        name: "Emilia",
        rating: 4,
        addedAt: "2025-09-24",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>kurs bardzo pomocny. Tylko filmiki za długie.</p>"
    },
    {
        name: "Wiktor",
        rating: 4,
        addedAt: "2025-09-24",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>są okej tylko trochę przy długie flmiki</p>"
    },
    {
        name: "Maja",
        rating: 5,
        addedAt: "2025-09-22",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>LEPIEJ ZAPAMIĘTUJE I LEPIEJ MI SIĘ UCZY</p>"
    },
    {
        name: "Szymon",
        rating: 5,
        addedAt: "2025-09-22",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>pomaga z moim problemami z nauką i jest bardzo fajny. nic dodać nic ująć jest po prostu perfekcyjny</p>"
    },
    {
        name: "Stanisław",
        rating: 5,
        addedAt: "2025-09-21",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Bardzo fajnie jest to ze filiki sa czedto nie zybt dlugie i nie zabieaja tyle czasu</p>"
    },
    {
        name: "Martyna",
        rating: 5,
        addedAt: "2025-09-16",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Kurs jest bardzo dobrze przygotowany, dużo wiedzy w nim podane</p>"
    },
    {
        name: "Tomasz",
        rating: 5,
        addedAt: "2025-09-14",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>stosuje wszystko co jest na kursie podawane i naprawde działa</p>"
    },
    {
        name: "Antonina",
        rating: 5,
        addedAt: "2025-09-13",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Pomaga mi zorganizowac prace na moich lekcjach.</p>"
    },
    {
        name: "Marysia",
        rating: 5,
        addedAt: "2025-09-11",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Kurs jest bardzo fajny. Przez niego mogę się dowiadywać o nowych rzeczach które pomogą mi w samorozwoju.</p>"
    },
    {
        name: "Paulina",
        rating: 5,
        addedAt: "2025-09-10",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>bardzo dobre doświadczenie</p>"
    },
    {
        name: "Magdalena",
        rating: 5,
        addedAt: "2025-09-09",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>som ciekawsze niż myślałam</p>"
    },
    {
        name: "Agnieszka",
        rating: 5,
        addedAt: "2025-09-08",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Póki co rozglądam się</p>"
    },
    {
        name: "Stefan",
        rating: 4,
        addedAt: "2025-09-08",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>kurs jest okej ale filmiki mogły by być więcej ale krótsze</p>"
    },
    {
        name: "Marysia",
        rating: 5,
        addedAt: "2025-09-05",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Słucham go czasami i jest ciekawy.</p>"
    },
    {
        name: "Wojciech",
        rating: 5,
        addedAt: "2025-09-02",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Bardzo fajnie mi się z nim pracuje, wszystko jest przedstawione w fajny sposób a efekty niektórych lekcji widzę już po krótkim czasie</p>"
    },
    {
        name: "Weronika",
        rating: 5,
        addedAt: "2025-08-31",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>umiem stosować techniki antyprokrastynacyjne. jest doskonale.</p>"
    },
    {
        name: "Tosia",
        rating: 5,
        addedAt: "2025-08-29",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p> Jest naprawdę dobrze wszystko tłumaczone. Wszystko rozumiem</p>"
    },
    {
        name: "Jarosław",
        rating: 5,
        addedAt: "2025-08-29",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Generalnie jest ok. Jedyny minus to to ze prowadzący momentami mówi nie wyraźnie, mam wrażenie ze chce w jak najkrótszym czasie przekazać materiał, żeby lekcje nie trwaly dlugo, i to jest ok.</p>"
    },
    {
        name: "Maciej",
        rating: 5,
        addedAt: "2025-08-27",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Fajne rzeczy, duzo sie dowiedzialem</p>"
    },
    {
        name: "Olek",
        rating: 5,
        addedAt: "2025-08-27",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>fajny kurs pozdrawiam cieplutko</p>"
    },
    {
        name: "Maria",
        rating: 5,
        addedAt: "2025-08-24",
        details: "",
        courseInfo: "Mama nastolatki z Kursu Efektywnego Działania",
        review: "<p>Kurs wartościowy dla nastolatka, uświadamia więcej spraw niż dorosły mógłby podejrzewać że będą dla dziecka nowoscia</p>"
    },
    {
        name: "Marysia",
        rating: 5,
        addedAt: "2025-08-24",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Super ! Polecam. Kurs naprawdę jest przydatny i dużo mi pomógł. Bardzo mi się podoba</p>"
    },
    {
        name: "Bartek",
        rating: 5,
        addedAt: "2025-08-20",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>mówią z sensem i myślę ż e zacznę się stosować</p>"
    },
    {
        name: "Aleksandra",
        rating: 5,
        addedAt: "2025-08-20",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>uswiadomił mi że na wiele rzeczy mam wpływ</p>"
    },
    {
        name: "Tomek",
        rating: 5,
        addedAt: "2025-08-17",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Mam problem z wysłuchaniem kursów przez moje lenistwo, kurs mi sie bardzo podoba, ale przez większość czasu nie chce mi sie go robic (prokrastynacja)</p>"
    },
    {
        name: "Leon",
        rating: 5,
        addedAt: "2025-08-16",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>fajny kurs dużo się od niego nauczyłem</p>"
    },
    {
        name: "Małgorzata",
        rating: 5,
        addedAt: "2025-08-14",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Materiały sa konkretne i praktyczne.</p>"
    },
    {
        name: "Dominika",
        rating: 5,
        addedAt: "2025-08-12",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Pomaga mi szerzej spojrzeć na możliwości żeby zacząć się rozwijać i nie martwić na zapas.</p>"
    },
    {
        name: "Karolina",
        rating: 5,
        addedAt: "2025-08-11",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Dużo się dowiedziałam nowych i bardzo pomocnych informacji.</p>"
    },
    {
        name: "Aleksandra",
        rating: 5,
        addedAt: "2025-08-09",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Kurs jest łatwy do zrozumienia i mile prowadzony</p>"
    },
    {
        name: "Piotr",
        rating: 5,
        addedAt: "2025-08-09",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Cieszę się, że dowiedziałem się jak organizować czas.</p>"
    },
    {
        name: "Antoni",
        rating: 5,
        addedAt: "2025-08-08",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>wygląda bardzo dobrze narazie, wszystko mi sie podoba</p>"
    },
    {
        name: "Edyta",
        rating: 5,
        addedAt: "2025-08-08",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Ddobrze mi się z nim pracuje</p>"
    },
    {
        name: "Nina",
        rating: 5,
        addedAt: "2025-08-06",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Bardzo fajny kurs, można się wiele nauczyć</p>"
    },
    {
        name: "Oliwier",
        rating: 4,
        addedAt: "2025-08-04",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Wszystko jest spoko, troszke za głośne intro i outro.</p>"
    },
    {
        name: "Mateusz",
        rating: 5,
        addedAt: "2025-08-04",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>10/10, nie mam żadnych uwag, jest super</p>"
    },
    {
        name: "Jurek",
        rating: 5,
        addedAt: "2025-07-28",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>mega to jest pomaga i to jak a poza tym wyjaśnia jasno</p>"
    },
    {
        name: "Krzysztof",
        rating: 5,
        addedAt: "2025-07-26",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Bardzo przyjemne, czuje większą motywację, wszystko odpowiada</p>"
    },
    {
        name: "Julia",
        rating: 4,
        addedAt: "2025-07-23",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Na razie bez zarzutów, muszę starać się wykonywać zadania z kursu bardziej regularnie</p>"
    },
    {
        name: "Tim",
        rating: 5,
        addedAt: "2025-07-21",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Zobaczyłem gdzie są moje błędy i gdzie mogę się poprawić</p>"
    },
    {
        name: "Eryk",
        rating: 5,
        addedAt: "2025-07-17",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Jest super. Pomaga mi w nauce do szkoły.</p>"
    },
    {
        name: "Łukasz",
        rating: 5,
        addedAt: "2025-07-16",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Mimo tego że nie zrobiłem jeszcze wiele, bardzo podoba mi się kurs co do tej pory</p>"
    },
    {
        name: "Igor",
        rating: 5,
        addedAt: "2025-07-13",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Kursy są fajne i przyjemne. A prowadzący bardzo przyjemnie omawia temat danego kursu.</p>"
    },
    {
        name: "Julia",
        rating: 5,
        addedAt: "2025-07-10",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Filmy pomagają w zrozumieniu, co jest istotne, aby zapanować nad swoim czasem.</p>"
    },
    {
        name: "Zosia",
        rating: 5,
        addedAt: "2025-07-07",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Zaskoczył mnie temat o marginalnych zyskach i dzięki temu zmobilizowałam się i przejrzałam cały dział. Dobrze działa- efektywnie!.</p>"
    },
    {
        name: "Karolina",
        rating: 5,
        addedAt: "2025-07-07",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Bardzo mi się podoba jak narazie, staram się wykorzystywać uzyskaną wiedzę w życiu codziennym</p>"
    },
    {
        name: "Marcin",
        rating: 4,
        addedAt: "2025-07-01",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Jest okej! Narazie mało nowych informacji ale i tak bardzo pomocne dla wielu osób</p>"
    },
    {
        name: "Wojtek",
        rating: 5,
        addedAt: "2025-06-18",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Bardzo dobże zrobiony, można sie wiele nauczyuć</p>"
    },
    {
        name: "Janek",
        rating: 5,
        addedAt: "2025-06-08",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>jest dobrze. nie mam żadnych uwag.</p>"
    },
    {
        name: "Natalia",
        rating: 4,
        addedAt: "2025-06-03",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Bardzo ciekawy Kurs. Można się dużo dowiedzieć. Dodałabym możliwość monitorowania swoich osiągnięć np. Regularności w przerabianiu filmów i materiałów</p>"
    },
    {
        name: "Piotr",
        rating: 5,
        addedAt: "2025-05-31",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Wszystko ok, chociaz czasem ciezko jest zmotywować sie do ćwiczeń</p>"
    },
    {
        name: "Julka",
        rating: 5,
        addedAt: "2025-05-28",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Bardzo fajnie, podoba mi sie i sie duzo nowych rzeczy ucze. wszystko super, filmiki duza ucza</p>"
    },
    {
        name: "Zuzanna",
        rating: 5,
        addedAt: "2025-05-22",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Bardzo fajny kurs polecam każdemu kto nie ma motywacji do nauki</p>"
    },
    {
        name: "Aleksander",
        rating: 5,
        addedAt: "2025-05-12",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Na razie zapoznaję się z materiałami. Myślę, że są wartościowe.</p>"
    },
    {
        name: "Ignacy",
        rating: 5,
        addedAt: "2025-05-12",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Jest ok, dalej walczę ;)</p>"
    },
    {
        name: "Łucja",
        rating: 5,
        addedAt: "2025-05-09",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Kurs mi się podoba ale nie mam czasu aby napisać wiecej</p>"
    },
    {
        name: "Antoni",
        rating: 5,
        addedAt: "2025-05-01",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Do tej pory nie zaobserwowałem żadnych błędów i dowiedziałem się co mam robić aby poprawić swoje wyniki</p>"
    },
    {
        name: "Tomek",
        rating: 5,
        addedAt: "2025-04-27",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Kurs jest bardzo fajny pomaga mi w nauce.</p>"
    }, {
        name: "Franciszek",
        rating: 5,
        addedAt: "2025-04-23",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Jest fajnie tylko muszę długo czekać żeby mi się odblokował tydzień. Niczego mi nie brakuje.</p>"
    },
    {
        name: "Patrycja",
        rating: 5,
        addedAt: "2025-04-21",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Dzięki kursowi lepiej mam zaplanowaną naukę. Kurs mi się podoba.</p>"
    },
    {
        name: "Tymoteusz",
        rating: 5,
        addedAt: "2025-04-19",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Wiem, jak się przygotować do testów, wiem, jak czytać ze zrozumieniem.</p>"
    },
    {
        name: "Tymon",
        rating: 5,
        addedAt: "2025-04-15",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Bardzo dobrze mi sie z panem wspolpracuje na spotkaniach grupowych. Zawsze moge zadac pytania i uzyskac pomoc. Czuje sie tam bardzo swobodnie. Kurs pomaga mi w nauce i systematycznosci. Po 3 tygodniach widze realna poprawe w mojej wydajnosci. Plan dominacji swietnie sie sprawdza i korzystam z niego codziennie. </p>"
    },
    {
        name: "Mateusz",
        rating: 5,
        addedAt: "2025-04-13",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Naprawdę fajny polecam każdemu. Wszystko mi pasuje i nie mam żadnych uwag.</p>"
    },
    {
        name: "Julia",
        rating: 5,
        addedAt: "2025-04-11",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Jestem bardzo zadowolona. Długo zajęło mi rozpoczęcie, ale jak już rodzice przestali mi ciągle o tym gadać, to poszlo jakos łatwiej :) Kurs jest bardzo wartosciowy i pomaga mi na codzien.</p>"
    },
    {
        name: "Sara",
        rating: 5,
        addedAt: "2025-04-06",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Bardzo mi się podoba sposób w który to wszystko jest tłumaczone. Kurs jest bardzo przydatny</p>"
    },
    {
        name: "Pola",
        rating: 4,
        addedAt: "2025-03-30",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Kurs jest ciekawy i dobrze rozplanowany, chociaż lekcje mogłyby być troszkę krótsze.</p>"
    },
    {
        name: "Jakub",
        rating: 5,
        addedAt: "2025-03-30",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Kurs jest naprawdę przydatny. Dowiedziałem się kilku rzeczy, które mi się przydały. Niczego mi nie brakowało.</p>"
    },
    {
        name: "Elżbieta",
        rating: 5,
        addedAt: "2025-03-25",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Kurs okazał się pomocny w motywacji i podejmowaniu nowych wyzwań. Niczego mi nie brakowało. Gdybym miała magiczną różdżkę to chciałabym tą całą wiedzę przyswoić od razu. Niestety jest to proces długotrwały. </p>"
    },
    {
        name: "Magda",
        rating: 5,
        addedAt: "2025-03-22",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Kurs jest bardzo pomagający. Na tą chwilę wdrażam w życie zadania, które są na tym kursie. Zrobiłabym tylko trochę krótsze lekcje, a tak to wszystko jest okej.</p>"
    },
    {
        name: "Ilona",
        rating: 5,
        addedAt: "2025-03-20",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Kurs jest opracowany zrozumiale, ale ja nie wykonuję systematycznie ćwiceń. Wszystko było w porządku, podoba mi się metoda małych kroków. Na razie niczego bym nie zmieniała.</p>"
    },
    {
        name: "Grzesiek",
        rating: 5,
        addedAt: "2025-03-11",
        details: "Uczeń III klasy Technikum",
        courseInfo: "Uczestnik programu MISTRZOWSKIE Wsparcie",
        review: "<p>Bardzo fajnie. Nauczyłem się jak lepiej zapamiętywać, bo przed zajęciami kułem na pamięć, a teraz lepiej mi to wychodzi. Na pewno nauczyłem się tego, jak lepiej się uczyć - np. mieć porządek i wyrzucić telefon z pokoju. Pomógł mi również schemat powtórek - robię to teraz z głową i nie jest to całkowicie losowe. Dziękuję za pomoc. </p>"
    },
    {
        name: "Zosia",
        rating: 5,
        addedAt: "2025-03-05",
        details: "Uczennica I klasy Technikum",
        courseInfo: "Uczestniczka programu MISTRZOWSKIE Wsparcie",
        review: "<p>Najbardziej podobało mi się stopniowe podejście. Planowanie bardzo mi się przydało. Miałam problem z organizacją - nie umiałam się zaangażować i przerobić tego co powinnam. Teraz jest o wiele łatwiej. Nauka też idzie mi znacznie lepiej i pamiętam o obowiazkach domowych. </p>"
    },
    {
        name: "Wiktoria",
        rating: 5,
        addedAt: "2025-03-01",
        details: "Uczennica III klasy Liceum",
        courseInfo: "Uczestniczka programu MISTRZOWSKIE Wsparcie",
        review: "<p>Ogólnie wszystko jasno wyjaśnione, fajnie, że była tablica udostępniona. Bardzo podobał mi się styl prowadzenia zajęć i przerabiany materiał. W sumie nie uważam, żeby miała na co narzekać, ewentualnie fakt, że częstotliwość wprowadzenia nowych rzeczy była dość duża. </p>"
    },
    {
        name: "Magdalena",
        rating: 5,
        addedAt: "2025-02-10",
        details: "Mama Huberta, maturzysty",
        courseInfo: "Uczestnik programu MISTRZOWSKIE Wsparcie",
        review: "<p>Czuję, że Hubertowi współpraca z Panem pokazała i uświadomiła parę ważnych rzeczy. Bardzo dziękuję, za to, co do tej pory dał Pan Hubertowi, myślę, że na pewno będzie to dla niego wspierająca wiedza.</p>"
    },
    {
        name: "Dawid",
        rating: 5,
        addedAt: "2025-02-09",
        details: "Uczeń VII klasy SP",
        courseInfo: "Uczestnik programu MISTRZOWSKIE Wsparcie",
        review: "<p>Ogolnie zajecia sie podobaly, duzo sie nauczylem. Najbardziej przydalo mi się robienie powtorek po zajeciach oraz techniki efektywnej nauki. Cykl Kobla tez byl bardzo ciekawym narzedziem. Postepy sa dobre i czuje ze dzialanie idzie mi znacznie lepiej.</p>"
    },
    {
        name: "Igor",
        rating: 5,
        addedAt: "2025-02-01",
        details: "Uczeń I klasy Liceum",
        courseInfo: "Uczestnik programu MISTRZOWSKIE Wsparcie",
        review: "<p>Hej, program był naprawdę super. Dzięki Twojemu podejściu czułem się swobodnie – fajny kontakt i luźna atmosfera bardzo mi pomogły. Najbardziej doceniam konkretne wskazówki dotyczące organizacji i efektywnej nauki. Szczególnie cykl Kolba, który co jakiś czas wprowadzaliśmy na zajęciach, pozwolił mi lepiej zrozumieć jak skutecznie uczyć się na własnych doświadczeniach. Czuję też wyraźną poprawę koncentracji, co przekłada się na moje wyniki w szkole i codzienne zadania.</p>"
    },
    {
        name: "Julia",
        rating: 5,
        addedAt: "2025-01-17",
        details: "Uczennica II klasy Liceum",
        courseInfo: "Uczestniczka programu MISTRZOWSKIE Wsparcie",
        review: "<p>hej mikołaj ogólnie bardzo podobają mi się te zajęcia, nauczyłam się o wiele więcej niż zakładałam; najbardziej przydatne są dla mnie rady dotyczące nauki i realizacji celów. najbardziej w zajęciach mi się podoba, że rzeczywiście słuchasz z czym mogę mieć problem i starasz się dostosować następną lekcje, żeby mi z tym pomóc. myślę, że też fajne jest to, że wszystko mi rozrysowujesz, bo u mnie rzeczywiście zapamiętanie czegoś z samego słuchu no jest dość ciężkie. na plus jest też fakt, że nie prowadzisz tych zajęć tak bardzo szkolnie (??), że po prostu mogę normalnie z tobą rozmawiać o wszystkim bez jakiegoś nacisku na to, że tqk naprawdę jesteś moim nauczycielem(?). </p>"
    },
    {
        name: "Dominik",
        rating: 5,
        addedAt: "2025-01-15",
        details: "Student ekonomii",
        courseInfo: "Uczestnik programu MISTRZOWSKIE Wsparcie",
        review: "<p>Hej, na pewno Gallup jest na plus, bo raz że podnosi samoświadomość i samoocenę, to jeszcze uruchamia fajne rozkminy na swój temat. <br/><br/>" +
            "A bardziej osobiście podoba mi sie Twoje realne podejście do zajęć. To znaczy, że nie sprzedajesz gruszek na wierzbie i nie klepiesz po ramionku, tylko efektywnie motywujesz i pokazujesz właśnie te techniki i narzedzia, dzięki którym można na prawdę wiele zdziałać w życiu.<br/><br/>" +
            "Z rzeczy które mi sie przydały i które wiem, że działają to chyba nie muszę mówić, bo to jest jakieś 80% materiału, który razem przerobiliśmy i ciężko trochę powiedzieć co konkretnie. </p>"
    },
    {
        name: "Ignacy",
        rating: 5,
        addedAt: "2024-12-18",
        details: "Uczeń II klasy Technikum",
        courseInfo: "Uczestnik programu MISTRZOWSKIE Wsparcie",
        review: "<p>Bardzo podobały mi się nasze zajęcia. Czułem się swobodnie i mogłem o wszystkim powiedzieć. Nie miałem żadnej spiny jak coś nie wychodziło. Z samego materiału najbardziej przydały mi się techniki efektywnej nauki, a przede wszystkim nauka poprzez dociekanie. Jest to bardzo zabawne i jednocześnie angażujące.</p>"
    },
];
